import React from 'react'
import { useTranslation } from 'react-i18next';
import { Badge, Card, CardBody, CardTitle, CardText } from 'reactstrap';
import Icon from '@mdi/react';
import {
    mdiFaceMan,
    mdiFaceWoman,
    mdiCheckDecagramOutline,
    mdiAlertCircleOutline
} from '@mdi/js';

import './UserListItem.css';

const UserListItem = ({ user, actions, selected, className, condensed }) => {
    const { t } = useTranslation();

    if (condensed)
        className = (className || '') + ' condensed';

    const color = 'light';

    if (selected)
        color = 'primary';

    return (
        <Card className={ `UserListItem ${className} ${selected ? 'text-white' : ''}` } color={color}>
            <CardBody>
                <CardText>
                    <CardTitle>
                        <Icon path={ user.gender === 'F' ? mdiFaceWoman : mdiFaceMan } size={1} />&nbsp;
                        { user.lastname }&nbsp;{ user.firstname }
                    </CardTitle>
                    <h5 className="badges">
                        <Icon
                            path={ user.enrolment?.status === 'ok' ? mdiCheckDecagramOutline : mdiAlertCircleOutline }
                            size={1}
                        />&nbsp;
                        <Badge>
                            { user.age }&nbsp;{ t('common.age_years') }
                        </Badge>
                    </h5>
                    <div className="actions">
                        { actions }
                    </div>
                </CardText>
            </CardBody>
        </Card>
    )
}

export default UserListItem;
